import fetchAlchemyInsights from '../services/fetchAlchemyInsights';
import sendAlchemyDataPoint from '../services/sendAlchemyDataPoint';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { AlchemyInsightsResponse } from '../schema/AlchemyInsightsResponse';
import createAlchemyClientContext from '../utils/createAlchemyClientContext';
import { trace } from 'owa-trace';

export default async function getAlchemyInsights(
    invokedBy: string,
    userText?: string,
    clientContextJson?: string
): Promise<AlchemyInsightsResponse> {
    let alchemyResponse: AlchemyInsightsResponse;
    let alchemyBucketId: string = 'EmptyBucket';
    let alchemyId: string = 'EmptyId';

    let userConfig = getUserConfiguration();

    let clientContext = isClientContextValid(clientContextJson)
        ? clientContextJson
        : createAlchemyClientContext(userConfig, invokedBy);

    alchemyResponse = await fetchAlchemyInsights({
        ClientContext: clientContext,
        Locale: userConfig.SessionSettings.UserCulture,
        Text: userText,
    });

    if (alchemyResponse && alchemyResponse.Solutions.length > 0) {
        if (alchemyResponse.CorrelationId) {
            alchemyId = alchemyResponse.CorrelationId;
        }
        if (alchemyResponse.Insights[0].BucketId) {
            alchemyBucketId = alchemyResponse.Insights[0].BucketId;
        }
    }

    sendAlchemyDataPoint({
        alchemyId: alchemyId,
        clientContext: clientContext,
        locale: userConfig.SessionSettings.UserCulture,
        alchemyBucketId: alchemyBucketId,
    });

    return alchemyResponse;
}

export function isClientContextValid(clientContextJson?: string): boolean {
    if (clientContextJson) {
        try {
            JSON.parse(clientContextJson);
            return true;
        } catch (e) {
            trace.warn(`getAlchemySolution: Invalid client context ${clientContextJson}`);
        }
    }

    return false;
}
